<template>
  <div :data-changes="changes">
    <app-input-search class="mb-2" v-model="searchTerm"></app-input-search>
    <div class="row" v-for="(l, i) in listCategorized" :key="i">
      <template v-if="searchTerm.length == 0">
        <div class="col">
          <h5>{{ i }}</h5>
          <div class="row px-3">
            <div
              class="col-6 col-sm-4 col-md-3 col-lg-2"
              v-for="(l1, i1) in l"
              :key="i1"
              style="padding-left: 3px; padding-right: 3px"
            >
              <ProductCard
                @click-add="clickAddHandler"
                :selected="selected.has(l1.id)"
                :product="l1"
                @click-remove="clickRemoveHandler"
                @clickless="clickLessHandler"
                :seeName="seeNames"
              ></ProductCard>
            </div>
          </div>
        </div>
      </template>
    </div>
    <template v-if="searchTerm.length > 0">
      <div class="row">
        <div
          class="col-6 col-sm-4 col-md-3 col-lg-2"
          v-for="(l1, i1) in listFiltered"
          :key="i1"
        >
          <ProductCard
            @clickAdd="clickAddHandler"
            :selected="selected.has(l1.id)"
            :product="l1"
            @clickRemove="clickRemoveHandler"
            @clickLess="clickLessHandler"
            :seeName="seeNames"
          ></ProductCard>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import ProductCard from "./ProductCard.vue";
import { DinnerService } from "./DinnerService";
import _ from "lodash";

export default {
  components: {
    ProductCard
  },

  // directives
  // filters

  props: {
    seeNames: {
      default: false
    }
  },

  data: () => ({
    list: [],
    listCategorized: {},
    searchTerm: "",
    selected: new Map(),
    changes: 0
  }),

  computed: {
    listFiltered() {
      return this.list.filter((x) => {
        let productName = "";
        productName = x.name;
        return (
          productName
            .toLowerCase()
            .trim()
            .search(this.searchTerm.toLowerCase()) > -1
        );
      });
    }
  },

  watch: {
    //
  },

  mounted() {
    DinnerService.getProducts({
      per_page: 1000,
      area_id: this.$store.state.user.area_id
    }).then((data) => {
      this.list = data.data.reverse();
      this.listCategorized = _.groupBy(data.data, "categorie_name");
    });
  },

  methods: {
    clickLessHandler(product) {
      if (this.selected.has(product.id)) {
        let tempProduct = this.selected.get(product.id);
        if (tempProduct.quantity == 1) {
          this.clickRemoveHandler(product.id);
        } else {
          this.selected.set(product.id, {
            ...tempProduct,
            quantity: tempProduct.quantity - 1
          });
          this.changes++;
          this.$emit("productRemoved");
        }
      }
    },
    reset() {
      this.selected = new Map();
    },
    getListSelected() {
      let selectedList = [];
      this.selected.forEach((x) => {
        selectedList.push(x);
      });
      return selectedList;
    },
    makeRequest() {
      this.$emit("makeRequest", this.getListSelected());
    },
    emitProducts() {},
    clickRemoveHandler(productId) {
      this.selected.delete(productId);
      this.changes++;
      this.$emit("productRemoved");
    },
    clickAddHandler(product) {
      if (!this.selected.has(product.id)) {
        this.selected.set(product.id, {
          id: product.id,
          name: product.name,
          unit_price: product.unit_price,
          original_unit_price: product.unit_price,
          quantity: 1
        });
      } else {
        let productProfile = this.selected.get(product.id);
        productProfile.quantity++;
        this.selected.set(product.id, productProfile);
      }
      this.changes++; // update view
      this.$emit("productSelected", product);
    }
  }
};
</script>
<style scoped></style>
